import {IUserPhone} from '../api-response/building/user-phone';

export class UserPhoneType {
    private static phoneTypeToName: Record<string, string> = {
        phone_home: 'Home',
        phone_cell: 'Mobile',
        phone_business: 'Business',
        phone_fax: 'Fax',
        phone_business_fax: 'Business Fax',
        phone_other: 'Other',
    };

    static fromUserPhone(phone: IUserPhone): UserPhoneType {
        return new UserPhoneType(
            Boolean(phone.isPrimaryPhone),
            phone.phone,
            phone.phoneType,
            phone.user,
        );
    }

    constructor(
        public isPrimaryPhone: boolean = true,
        public phone: string = '',
        public phoneType: string = 'phone_home',
        public user: number = undefined,
        public realPhoneType: string = undefined,
    ) {
    }

    getHumanReadableType() {
        if (UserPhoneType.phoneTypeToName.hasOwnProperty(this.phoneType)) {
            return UserPhoneType.phoneTypeToName[this.phoneType];
        }
        return UserPhoneType.phoneTypeToName['phone_other'];
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/UserPhoneType.ts